import {
    StyleCCBar,
    AllowCookie,
    GetPermissions,
    CcInViewport,
    ShowCC
} from 'scripts/utils/npo-cookie-check';
import * as Log from 'scripts/utils/logger';
import 'scripts/utils/jquery-size';
import CcmQueue from 'scripts/modules/ccm-queue';
import Placeholder from 'scripts/modules/placeholder';
import { deepmerge } from 'scripts/utils/deepmerge';

const Cookies = require('cookies-js/dist/cookies');
const InViewport = require('scripts/utils/in-viewport');

window.At = window.At || {};
window.At.Util = window.At.Util || {};

/**
 * DeepMerge function as replacement for Object.assign (doesn't deep merge) and jQuery $.extend
 */
window.At.Util.DeepMerge = deepmerge;


window.At.Util = window.At.Util.DeepMerge(window.At.Util, {
    Cookie: {
        CcmCheck: true,
        Set: Cookies.set,
        Get: Cookies.get,
        Expire: Cookies.expire,
        Enable: Cookies.enable,
        Defaults: Cookies.defaults,
        ccmQueue: new CcmQueue(),
    },
    InViewport,
    Log: Log.Log,
    Error: Log.Error,
    Warn: Log.Warn,
    Info: Log.Info,
});

StyleCCBar();

At.Util.Cookie.ccmQueue.callOnAllow('necessary', () => {
    window.At.Util = window.At.Util.DeepMerge(window.At.Util, {
        Cookie: {
            Allow: AllowCookie,
            Permissions: GetPermissions,
        },
        ShowCC,
        CcInViewport
    });
});

/**
 * set an interval, if the Cookie-banner is loaded and visible trigger the AtCore:CcmVisible event
 * @type {number}
 */
const ccmVisibleChecker = setInterval(function () {
    const ccmVisible = (window.ccm !== undefined
        && (window.ccm.has_banner() !== undefined && window.ccm.has_banner() === true)
        && (typeof At.Util.CcInViewport === 'function' && At.Util.CcInViewport() === true));

    const ccmReady = (window.ccm !== undefined
        && window.ccm.has_banner() !== undefined
        && window.ccm.has_banner() === false);

    if (ccmVisible) {
        $(window).trigger('AtCore:CcmVisible');
    }

    // stop the interval if window.ccm is loaded
    if (ccmVisible || ccmReady) {
        clearInterval(ccmVisibleChecker);
    }
}, 10);

$(window).on('AtCore:CcmVisible', () => {
    $('body').addClass('has--ccm-visible');
});


// Self invoking function on DOM load
$(() => {
    // For each of the founded data attr create a placeholder
    $('[data-at-ccm-placeholder]').each(Placeholder.prototype._attach);
});

